/** @format */

export * from './color-swatch.module';
